export default __webpack_public_path__ + "static/media/name_background.9048fe76.png";